import { redirect } from 'react-router-dom';
import { httpGet } from '../../store/externalCalls/httpCalls';
import { createSession } from '../../store/actions/sessionActions';
import store from '../../store/store';

export const sportRoomLoader = async ({ params, request }) => {
    const { mainHubSlugName, spaceSlugName } = params;

    if (!mainHubSlugName || !spaceSlugName) {
        return redirect('/wlpro');
    }

    try {
        const dispatch = store.dispatch;

        const url = new URL(request.url);
        const pathname = url.pathname;

        // Ejemplos:
        // /wlpro/xtadium/space/interactables-space/home
        // /wlpro/xtadium/space/interactables-space/canvas/androidXR_test_config
        const spaceIndex = pathname.indexOf('/space/');

        const spacePath = spaceIndex !== -1
            ? pathname.substring(spaceIndex)
            : null;

        const response = await httpGet(
            `loaderSpace?path=${encodeURIComponent(
                spacePath || `/${spaceSlugName}`
            )}`
        );

        if (response?.redirectTo) {
            return redirect(response.redirectTo);
        }

        const sportRoom = response?.sportRoom;

        if (!sportRoom?.id) {
            return redirect(
                `/wlpro/${mainHubSlugName}/space`
            );
        }

        const sportRoomId = parseInt(sportRoom.id, 10);
        const mainHubId = parseInt(sportRoom.mainHubId, 10);

        const appConfigs = Array.isArray(sportRoom.appConfigs)
            ? sportRoom.appConfigs
            : [];

        const mainHubName = response?.mainHubName;

        // El backend ya ha resuelto:
        // configName -> areaId
        const configName = response?.configName ?? '';
        const areaId = response?.areaId ?? null;

        dispatch(
            createSession({
                spaceName: response?.spaceName ?? sportRoom.slug,
                sportRoomId,
                mainHubId,
                mainHubName,
                mainHubSlugName,
                slug: sportRoom.slug,
                appId: sportRoomId,
                configName,
                ...(areaId !== null
                    ? { areaId: parseInt(areaId, 10) }
                    : {}),
            })
        );

        return {
            sportRoom,
            mainHubSlugName,
            mainHubName,
            mainHubId,
            sportRoomId,
            slug: sportRoom.slug,
            spaceName: response?.spaceName ?? sportRoom.slug,
            appConfigs,

            // Config del Space
            configName,
            areaId,

            spaces: response?.spaces ?? [],
            notFound: response?.notFound ?? false,
            configs: response?.configs ?? [],
        };

    } catch (error) {
        console.error('loaderSpace error', error);

        return redirect(
            `/wlpro/${mainHubSlugName}/space`
        );
    }
};